export const getTime = (time: string) => {

    let a = Number(time) *1000
    let d = new Date(a)

    return d.toLocaleDateString("ru-RU");

}